import axiosConfig from '../../../config/axios.config';
import axios from 'axios';

export default emailAssets => {
  console.log(emailAssets);
  return new Promise((resolve, rej) => {
    console.log('start staging')
    const assets = emailAssets.slice();
    let assetIds = [];
    const unStage = () => {
      const asset = assets.pop();
      const total = assets.length;
      // removed 'axiosConfig.auth' as token is updated on login
      axios.get(axiosConfig.localUrl + '/backend/unstage_media/' + asset._id)
      .then(res => {
        console.log(res)
        if (res.error) rej(false)
        else {
          assetIds.push(res.data.media_file._id);
          if (total) unStage()
          else { return resolve(assetIds) }
        }
      })
      .catch(err => {
        console.error(err)
        return rej(false);
      })
    }
    unStage();
  });
}
